(function () {
  function initMarquee(wrapper) {
    const speed = Number(wrapper.dataset.marqueeSpeed || 45); // px/second
    const infinite = (wrapper.dataset.marqueeInfinite || "false") === "true";

    // Encontrar el scroller real del componente slideshow
    const scroller =
      wrapper.querySelector('slideshow-slides[ref="scroller"]') ||
      wrapper.querySelector("slideshow-slides") ||
      wrapper.querySelector(".slideshow__slides") ||
      wrapper.querySelector("[data-slideshow-scroller]");

    if (!scroller) return;

    // Para marquee, el snap estorba
    scroller.style.scrollSnapType = "none";

    // Loop infinito duplicando slides
    const slides = Array.from(scroller.children || []);
    if (infinite && slides.length) {
      // Evita duplicar dos veces si Shopify re-renderiza
      if (!scroller.dataset.marqueeCloned) {
        slides.forEach((node) => scroller.appendChild(node.cloneNode(true)));
        scroller.dataset.marqueeCloned = "true";
      }
    }

    let rafId = null;
    let paused = false;
    let lastTs = null;

    function step(ts) {
      if (paused) {
        lastTs = ts;
        rafId = requestAnimationFrame(step);
        return;
      }

      if (lastTs == null) lastTs = ts;
      const dt = (ts - lastTs) / 1000; // seconds
      lastTs = ts;

      const dx = speed * dt; // px
      scroller.scrollLeft += dx;

      // Reset para loop
      if (infinite) {
        const half = scroller.scrollWidth / 2;
        if (scroller.scrollLeft >= half) {
          scroller.scrollLeft -= half;
        }
      }

      rafId = requestAnimationFrame(step);
    }

    function pause() {
      paused = true;
    }

    function resume() {
      paused = false;
    }

    // Pausa en hover/focus (cursor encima de alguna marca)
    wrapper.addEventListener("mouseenter", pause);
    wrapper.addEventListener("mouseleave", resume);
    wrapper.addEventListener("focusin", pause);
    wrapper.addEventListener("focusout", resume);

    // En mobile: pausa mientras el usuario toca/arrastra
    wrapper.addEventListener("touchstart", pause, { passive: true });
    wrapper.addEventListener("touchend", resume, { passive: true });
    wrapper.addEventListener("touchcancel", resume, { passive: true });

    // Arranca
    rafId = requestAnimationFrame(step);

    // Limpieza si Shopify remonta (opcional)
  const observer = new MutationObserver(() => {
  // si Shopify re-renderiza el wrapper, reinicia el marquee (opcional)
  });
  observer.observe(wrapper, { childList: true, subtree: true });

  }

  function boot() {
    document
      .querySelectorAll('.resource-list__carousel[data-marquee="true"]')
      .forEach(initMarquee);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  // Para navigations internas (Shopify/Theme scripts)
  document.addEventListener("shopify:section:load", boot);
})();
